import { Icon, Spinner, Typography, TypographyType } from '@/components/common';
import { TooltipComponent } from '@/components/common/tooltip';
import Icons from '@/const/icons';
import clsx from 'clsx';
import Image from 'next/image';
import * as React from 'react';

interface Props {
	title: string;
	classNameTitle?: string;
	icon: string;
	children: React.ReactNode;
	className?: string;
	description?: string;
	isLoading?: boolean;
	classNameContent?: string;
	classNameHeader?: string;
	iconWidth?: number;
	iconHeight?: number;
	titleTypography?: TypographyType;
	customButton?: React.ReactNode;
	tooltipContent?: React.ReactNode;
	tooltipLabel?: string | React.ReactNode;
	tooltipCustomLabel?: React.ReactNode;
	tooltipClassName?: string;
	tooltipClassNameLabel?: string;
	showScroll?: boolean;
	toolTipSide?: 'top' | 'right' | 'bottom' | 'left' | undefined;
}

export const CardContainerMetrics: React.FC<Props> = ({
	className,
	classNameTitle,
	children,
	icon,
	title,
	description,
	isLoading,
	classNameContent,
	titleTypography,
	customButton,
	tooltipContent,
	tooltipLabel,
	tooltipClassName,
	tooltipCustomLabel,
	tooltipClassNameLabel,
	iconWidth = 61,
	iconHeight = 48,
	showScroll = true,
	classNameHeader,
	toolTipSide,
}) => {
	// const getIsDisabled = (): boolean | undefined => {
	// 	return (
	// 		status === 'Archived' ||
	// 		status === 'Resolved Case' ||
	// 		(status && END_STATUSES_CASE.includes(status))
	// 	);
	// };
	return (
		<div
			className={clsx(
				'bg-white rounded-3xl w-full border border-grey-100 p-6',
				// {
				// 	'!bg-bg-disabled border border-[#0D061614]': getIsDisabled(),
				// },
				className
			)}
		>
			<div
				className={clsx(
					'flex flex-col xl:flex-row xl:items-center xl:justify-between mb-4',
					classNameHeader
				)}
			>
				<div className="flex items-center gap-3">
					<Image
						src={icon}
						alt="icon"
						width={iconWidth}
						height={iconHeight}
						className="self-start"
						unoptimized
					/>
					<div className="3xl:ml-2">
						<Typography
							type={titleTypography || 'semibold-16'}
							className={clsx('text-black text-left', classNameTitle)}
						>
							{title}
						</Typography>
						{description && (
							<Typography type="regular-14" className="opacity-60">
								{description}
							</Typography>
						)}
					</div>
					{(tooltipLabel || tooltipCustomLabel) && (
						<TooltipComponent
							side={toolTipSide}
							label={tooltipLabel}
							customLabel={tooltipCustomLabel}
							trigger={
								tooltipContent || (
									<div>
										<Icon
											src={Icons.infoCircle}
											className="text-black opacity-60"
											width={20}
											height={20}
										/>
									</div>
								)
							}
							className={tooltipClassName}
							classNameLabel={tooltipClassNameLabel}
						/>
					)}
				</div>
				{customButton && customButton}
			</div>
			<div
				className={clsx(
					{ 'overflow-auto scroll-custom': showScroll },
					'h-auto',
					classNameContent
				)}
			>
				{isLoading ? (
					<div className="flex w-full justify-center items-center my-5">
						<Spinner className="w-8 h-8" />
					</div>
				) : (
					children
				)}
			</div>
		</div>
	);
};
